import React, { useCallback, useEffect, useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { appendMetadataWithIndex } from 'gw-jutro-adapters-react';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './DriverAssignmentComponent.metadata.json5';
import messages from './DriverAssignmentComponent.messages';
import styles from './DriverAssignmentComponent.module.scss';
import classNames from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {
    Icon,
    DropdownSelectField,
    Link,
    InputNumberField,
    CheckboxField
} from '@jutro/components';

function DriverAssignmentComponent(props) {
    const {
        data: vehicleVM,
        labelPosition,
        id,
        index: vehicleIndex,
        onValidate,
        updateWizardData,
        submissionVM,
        vehicleID
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    const vehicleDrivers = submissionVM.lobData.businessAuto.coverables.vehicleDrivers.children.filter((v) => {
        return v.vehicleID.value == vehicleID
    })
    
    const formattedMetadata = useMemo(() => {
        return appendMetadataWithIndex(metadata.pageContent, vehicleIndex);
    }, [vehicleIndex]);

    useEffect(() => {        
        // if(vehicleDrivers && vehicleDrivers.length == 0 && vehicleVM.vehicleType.value && vehicleVM.vehicleType.value.code !== 'Trailer_EY'
        //     && vehicleVM.vehicleType.value.code !== 'CommercialVehTrailer_EY') {
        //     addVehicleDriver();
        // }
        if(vehicleDrivers && vehicleDrivers.length == 0 && vehicleVM.vehicleType.value) {
        addVehicleDriver();
        }
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid, vehicleVM]);

    const handleValueChange = useCallback(
        (value, path, index) => {
            updateWizardData(submissionVM);
        },
        [submissionVM, vehicleVM]
    );

    const removeAssignmentItem = (e, index, item) => {
        let currentVehicleDrivers = submissionVM.lobData.businessAuto.coverables.vehicleDrivers.value.filter((v) => {
            return v.vehicleID == vehicleDrivers[index].value.vehicleID; 
        });
        currentVehicleDrivers.splice(index, 1);
        const otherVehcileDrivers = submissionVM.lobData.businessAuto.coverables.vehicleDrivers.value.filter((v) => {
            return v.vehicleID != vehicleDrivers[index].value.vehicleID
        });
        submissionVM.lobData.businessAuto.coverables.vehicleDrivers.value = otherVehcileDrivers.concat(currentVehicleDrivers);
        updateWizardData(submissionVM);
    }

    const addVehicleDriver = useCallback(
        (event) => {
            event && event.preventDefault();
            const { _xCenter, _dtoName } = submissionVM.lobData.businessAuto.coverables.vehicleDrivers;
            let vehicleDriverDTO = {
                isValidationRequired: true,
                vehicleType: vehicleVM.vehicleType.value.code
            };
            if(vehicleVM.value.fixedId !== undefined && vehicleVM.value.fixedId !== 11111) {
                vehicleDriverDTO.vehicleID = vehicleVM.value.fixedId
            } else {
                vehicleDriverDTO.vehicleTempID = vehicleVM.value.tempID
            }            
            if(vehicleVM.vehicleType.value.code === 'Commercial' || vehicleVM.vehicleType.value.code === 'CommercialVehTrailer_EY' 
            || vehicleVM.vehicleType.value.code === 'FuneralDirectors' || vehicleVM.vehicleType.value.code === 'FarmBuses_EY'){
                vehicleDriverDTO.isCommercialVehicle = true;
            }
            const vehicleDriverVM = viewModelService.create(vehicleDriverDTO, _xCenter, _dtoName);
            submissionVM.lobData.businessAuto.coverables.vehicleDrivers.value.push(vehicleDriverVM.value);
            updateWizardData(submissionVM);
        },
        [vehicleVM, submissionVM, viewModelService, vehicleDrivers]
    );

    const getTableCell = useCallback(
        (item, index, props) => {           
            var path = props.path;
            if (path == 'driverTempID') {
                const value = item.driverTempID ? item.driverTempID.value: '';
                const driverIDs = vehicleDrivers.filter((d) => {  return !!(d.driverTempID.value) })
                .map((vd)=>{ return vd.driverTempID.value });

                const drivers = submissionVM.lobData.businessAuto.coverables.drivers.value.filter((driver) => {                    
                    return driverIDs.indexOf(driver.publicID) == -1 || !!(item.driverTempID.value && item.driverTempID.value == driver.publicID)  //|| !!(item.driverTempID.value && driverIDs.indexOf(item.driverTempID.value) != -1)
                });

                const availableValues = drivers.map((driver) => {
                    return {
                        code: driver.publicID !== undefined ? driver.publicID : driver.person.firstName+':'+driver.person.lastName+':'+driver.licenseNumber,
                        name: driver.person.firstName+' '+driver.person.lastName
                    };
                });

                return (
                    <DropdownSelectField
                        id={index + path + vehicleIndex}
                        className={styles.coverageForm}
                        onValueChange={(value, path)=>{
                            item.driverTempID = value;
                            handleValueChange(value, path, index)
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable={true}
                    />
                );
            }
            else if (path == 'driverType') {
                const value = (item && item.driverType && item.driverType.value)  ? item.driverType.value : undefined;
                const availableValues = vehicleDrivers[index] && vehicleDrivers[index].driverTypeWithFilter ? vehicleDrivers[index].driverTypeWithFilter.aspects.availableValues.map((typeCode) => {
                   return {
                        code: typeCode.code,
                        name: translator({
                            id: typeCode.name,
                            defaultMessage: typeCode.name
                        })
                    };
                }) : [];
                return (
                    <DropdownSelectField
                        id={index + path + vehicleIndex}
                        className={styles.coverageForm}
                        onValueChange={(value, path)=>{
                            item.driverType.value = value
                            handleValueChange(value, path, index)
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable={true}
                    />
                );
            }
            else if(path == 'yearsExp') {
                const value = (item && item.yearsExp && !_.isUndefined(item.yearsExp.value))  ? item.yearsExp.value : undefined;
                return (
                    <InputNumberField
                        id={index + path + vehicleIndex}
                        className={styles.coverageForm}
                        onValueChange={(value, path)=>{
                            item.yearsExp.value = value;
                            handleValueChange(value, path, index)
                        }}
                        path={path}
                        value={value}
                    >
                    </InputNumberField>
                );
            }
            else if(path == 'isOccDriverAndRateable_EY') {
                let value = (item && item.isOccDriverAndRateable_EY && item.isOccDriverAndRateable_EY.value)  ? item.isOccDriverAndRateable_EY.value : false;
                const showRateableindexes = vehicleDrivers.filter((vd) => { 
                    return (vd.driverType && vd.driverType.value && vd.driverType.value.code == 'occ')
                });
                const isRateableReadOnly = showRateableindexes !== undefined && showRateableindexes.length > 1 ? false : true;
                if(isRateableReadOnly && (item.driverType && item.driverType.value && item.driverType.value.code == 'occ')){
                    value = true;
                    item.isOccDriverAndRateable_EY.value = true
                }
                const isRateableVisible = (item.driverType.value && item.driverType.value.code == 'occ') ? true : false;
                return (
                    <div>
                        <CheckboxField
                            id={index + path + vehicleIndex}
                            className={styles.coverageForm}
                            onValueChange={(value, path)=>{
                                const vDrivers = submissionVM.lobData.businessAuto.coverables.vehicleDrivers.children;
                                if(vDrivers.length > 1){
                                    _.each(vDrivers, (vd) => {
                                        vd.isOccDriverAndRateable_EY.value = false; 
                                    })
                                }                                
                                item.isOccDriverAndRateable_EY.value = value;
                                handleValueChange(value, path, index)
                            }}
                            value={!!value}
                            path={path}
                            disabled={isRateableReadOnly}
                            visible={isRateableVisible}
                        />
                    </div>
                );
            }
        },
        [vehicleVM, submissionVM, handleValueChange, vehicleDrivers]
    );

    const removeAssignmentRow = useCallback(
        (item, index) => {
            return (
                <Link
                    onClick={(e) => removeAssignmentItem(e, index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            );
        },
        [removeAssignmentItem]
    );

    const generateOverrides = () => {
        if(!vehicleDrivers) {
            return {}
        };
        var showYearsOfExp = vehicleVM.vehicleType.value.code == 'FuneralDirectors' || vehicleVM.vehicleType.value.code == 'Commercial'
        || vehicleVM.vehicleType.value.code == 'CommercialVehTrailer_EY' || vehicleVM.vehicleType.value.code == 'FarmBuses_EY';      
        var showRateable = vehicleDrivers.filter((vd) => { 
            return (vd.driverType && vd.driverType.value && vd.driverType.value.code == 'occ')
        }).length > 0;
        const overrideProps = vehicleDrivers.map((value, index) => {
            return {               
                [`driverYearsOfExperienceHeader${vehicleIndex}`]: {
                    visible: showYearsOfExp
                },
                [`isOccDriverAndRateable_EY${vehicleIndex}`]: {
                    visible: showRateable && vehicleVM.vehicleType.value.code == 'PrivatePassenger_EY'
                }
            };
        });

        return Object.assign({}, ...overrideProps);
    }

    const getHeaderName = (vehicle) => {
        var headerName = 'Vehicle'     
        headerName += (vehicle.make || vehicle.model) ? ': ' : '';
        headerName += vehicle.year ? vehicle.year + ' ' : '';
        headerName += vehicle.make ? vehicle.make + ' ' : '';
        headerName += vehicle.model ? vehicle.model : '';
        return headerName;
   };

    const getYearExpHeader = () => {
        return <div>{translator(messages.baDriverAssignmentYears)} <span class={styles.required}>*</span></div>
    };    

    const overrideProps = {
        '@field': {
            labelPosition,
            showOptional: false,
            showRequired: true
        },
        [`driverAssignmentTable${vehicleIndex}`]: {
            data: vehicleDrivers,
            //visible: vehicleVM.vehicleType.value.code != 'CommercialVehTrailer_EY' && vehicleVM.vehicleType.value.code != 'Trailer_EY'
        },
        [`addDriverAssignmentButtonId${vehicleIndex}`]:{
            //disabled: vehicleVM.vehicleType.value.code == 'CommercialVehTrailer_EY' || vehicleVM.vehicleType.value.code == 'Trailer_EY'
        },
        [`baAdddriverAssignmentSection${vehicleIndex}`]: {
            content: getHeaderName(vehicleVM.value)
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addVehicleDriver: addVehicleDriver,
            getTableCell: getTableCell,
            onValidate: setComponentValidation,
            removeAssignmentTableRow: removeAssignmentRow,
            getYearExpHeader: getYearExpHeader
        }
    };

    const data = {
        vehicle: vehicleVM
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => {
            return readViewModelValue(
                formattedMetadata,
                vehicleVM,
                fieldId,
                fieldPath,
                overrideProps
            );
        },
        [vehicleVM, formattedMetadata, overrideProps]
    );

    return (
        <ViewModelForm
            model={data}
            uiProps={formattedMetadata}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

DriverAssignmentComponent.propTypes = {
    data: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    path: PropTypes.string,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    readOnlyFields: PropTypes.arrayOf(PropTypes.string),
    showOptional: PropTypes.bool,
    index: PropTypes.string,
    id: PropTypes.string.isRequired
};
DriverAssignmentComponent.defaultProps = {
    data: {},
    labelPosition: 'left',
    path: undefined,
    readOnlyFields: [],
    showOptional: true,
    index: 0
};
export default DriverAssignmentComponent;
